export const COVERED = 'covered';
export const NOT_COVERED = 'not_covered';
export const PARTIAL = 'partial';
